import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSiteContent } from "@/lib/content";

/**
 * Sticky bottom "Book a fix" bar for mobile only (hidden ≥ md breakpoint).
 * Lives inside SiteFooter so every public page gets it, and so dashboards
 * / auth pages (which don't render SiteFooter) stay clean.
 */
export default function MobileBookingBar() {
  const { user } = useAuth() || {};
  const { content } = useSiteContent();
  const price = content?.hero?.flat_price || "₹599";
  const target = user ? "/dashboard" : "/register";

  return (
    <div
      data-testid="mobile-booking-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#0A1628] border-t border-white/10 shadow-[0_-6px_20px_rgba(0,0,0,0.25)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <div className="min-w-0">
          <div data-testid="mobile-booking-bar-label" className="text-white font-semibold text-sm leading-tight truncate">
            Standard Fix · {price}
          </div>
          <div className="text-[11px] text-white/60 leading-tight mt-0.5">Flat fee, no hidden charges</div>
        </div>
        <Link to={target} className="shrink-0">
          <button
            data-testid="mobile-booking-bar-cta"
            className="rounded-full bg-brand hover:bg-brand-dark text-white font-semibold h-11 px-5 text-sm shadow-btn transition-colors"
          >
            Book a fix
          </button>
        </Link>
      </div>
    </div>
  );
}
